import { Directive } from '@angular/core';
import { BrnCollapsibleContent } from '@spartan-ng/brain/collapsible';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
	selector: '[hlmCollapsibleContent],hlm-collapsible-content',
	hostDirectives: [{ directive: BrnCollapsibleContent, inputs: ['id'] }],
	host: { 'data-slot': 'collapsible-content' },
})
export class HlmCollapsibleContent {
	constructor() {
		classes(() => 
      // default:
      // 'data-[state=closed]:hidden'
      
      // animation:
      'block overflow-hidden transition-all data-[state=closed]:block data-[state=closed]:h-0 data-[state=open]:h-(--brn-collapsible-content-height)'
    );
	}
}
